<div class="gt">
  <div class="bk-panel gt__panel">
    <data-table label="Tags" [seamless]="true" [loading]="loading" [maxHeight]="'640px'" [skeletonColumns]="5">
      @if (loadError) {
        <div class="gt-error" role="alert">
          <p class="gt-error__text">{{ loadError }}</p>
          <button type="button" class="bk-btn bk-btn--ghost" (click)="load()">Load again</button>
        </div>
      } @else if (rows.length > 0) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col" class="col-check">
                <label class="gt-check-hit">
                  <input
                    type="checkbox"
                    class="gt-check"
                    [checked]="getIsAllSelected"
                    [indeterminate]="someOnPageSelected"
                    (change)="toggleSelectAllTags()"
                    aria-label="Select every tag on this page"
                  />
                  <span class="gt-check-all" aria-hidden="true">Select all</span>
                </label>
              </th>
              <th scope="col" class="col-name">Tag</th>
              <th scope="col" class="col-num">Members</th>
              <th scope="col" class="col-b">Created</th>
              <th scope="col" class="col-a">Updated</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr
                class="is-link"
                tabindex="0"
                [class.is-selected]="getTagIsSelected(row.tag)"
                (click)="goToTagDetail(row.tag.uuid || '')"
                (keydown.enter)="openFromKeyboard($event, row.tag)"
              >
                <td class="col-check" (click)="$event.stopPropagation()">
                  <label class="gt-check-hit">
                    <input
                      type="checkbox"
                      class="gt-check"
                      [checked]="getTagIsSelected(row.tag)"
                      (change)="selectTag(row.tag)"
                      [attr.aria-label]="'Select ' + row.name"
                    />
                  </label>
                </td>
                <td class="col-name">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ row.name }}</span>
                    <span class="bk-msg__preview">
                      @if (row.description) {
                        {{ row.description }}
                      } @else {
                        <span class="gt-faint">No description</span>
                      }
                    </span>
                  </span>
                </td>
                <td class="col-num">
                  @switch (countState(row.tag)) {
                    @case ('loading') {
                      <span class="bk-skel gt-count-skel" aria-hidden="true"></span>
                      <span class="bk-sr-only">Counting members</span>
                    }
                    @case ('none') {
                      <span class="gt-faint" title="The member count did not load" aria-hidden="true">—</span>
                      <span class="bk-sr-only">Count did not load</span>
                    }
                    @default {
                      <span class="gt-count">{{ formatCount(countOf(row.tag)) }}</span>
                      <span class="gt-num-label">{{ countOf(row.tag) === 1 ? ' member' : ' members' }}</span>
                    }
                  }
                </td>
                <td class="quiet col-b" [attr.title]="row.createdTitle">{{ row.created }}</td>
                <td class="quiet col-a" [attr.title]="row.updatedTitle">{{ row.updated }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <button
                      *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Message contacts tagged ' + row.name"
                      matTooltip="Message this tag"
                      (click)="$event.stopPropagation(); messageTag(row.tag)"
                    >
                      <span class="bk-sym" aria-hidden="true">send</span>
                    </button>
                    <button
                      *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Edit ' + row.name"
                      matTooltip="Edit"
                      (click)="$event.stopPropagation(); openEditModal(row.tag)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
                      type="button"
                      class="bk-icon-btn gt-danger"
                      [attr.aria-label]="'Delete ' + row.name"
                      matTooltip="Delete"
                      (click)="$event.stopPropagation(); openDeletePrompt(row.tag)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                    <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          icon="tags"
          message="No tags yet"
          [hint]="searchTerm.trim() ? '' : 'Create one with New tag, then tag the contacts you message together.'"
          [query]="searchTerm"
          size="medium"
          (clear)="clearFilters.emit()"
        />
      }
    </data-table>
  </div>

  @if (!loadError && tagsPagination.totalElements > 0) {
    <div class="gt__pager">
      <app-pagination
        [currentPage]="tagsPagination.pageNumber"
        [totalPages]="tagsPagination.totalPages"
        [totalItems]="tagsPagination.totalElements"
        [pageSize]="pageSize"
        [loading]="loading"
        (changePage)="updateTagPage($event)"
        (onNext)="goToNextPage()"
        (onPrev)="goToPreviousPage()"
        (pageSizeChange)="onPageSizeChange($event)"
      />
    </div>
  }
</div>

<!-- MODALS -->
<app-prompt-card
  [title]="'Delete ' + (selectedTag?.name || 'this tag') + '?'"
  buttonText="Delete tag"
  tone="danger"
  impact="This cannot be undone."
  impactIcon="warning"
  [openModal]="showDeletePrompt"
  (onClose)="closeDeletePrompt()"
  (onButtonClick)="deleteTag()"
  [loading]="deleting"
>
  <p class="gt-prompt">{{ deleteImpact }}</p>
</app-prompt-card>

<edit-tag-modal
  [selectedTag]="selectedTag"
  (closeModal)="closeEditModal()"
  [modalOpen]="showEditModal"
/>
